import React from 'react'

import useViewModel from './ViewModel'

const PileItemImagePrint: React.FC = () => {
  const { pics } = useViewModel()

  return (
    <div style={{ height: 'auto', margin: '0 auto', marginTop: '20px', width: '50vw' }}>
      <div className='row mx-auto g-10'>
        {pics.map((pic: any, idx: number) => (
          <div className='col-12' key={`pile-item-image-${idx}`}>
            <div className='h-300px'>
              <img
                className='h-100 w-100 object-fit-contain'
                src={`${process.env.REACT_APP_BACKEND_API_URL}${pic}`}
                onError={(e: any) => {
                  e.target.onerror = null
                  e.target.src = 'https://via.placeholder.com/300'
                }}
                alt={`${pic} ${idx + 1}`}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PileItemImagePrint
